import { useCallback, useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import RecommendationsContainer from '../../containers/RecommendationsContainer';
import useWootricSurvey from '../../hooks/useWootricSurvey';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import AnnouncementsSection from '../../features/announcements/components/AnnouncementsSection';
import HomePageSection from './HomePageSection';
import GetStartedSearchPrompt from '../../features/search/components/GetStartedSearchPrompt';
import MostPopularCertificates from '../MostPopularCertificates/MostPopularCertificates';
import { PersonaRecommendations } from '../../features/persona/PersonaRecommendations';
import FeaturedSection from '../../features/internalContent/components/FeaturedSection';
import { usePersonalizedHomepageOrder } from '../../features/personalization/hooks/usePersonalizedHomepageOrder';
import { Metrics } from '../../Metrics';
import { SectionCarousel } from '../SectionCarousel';
import { SkeletonBlock, SkeletonWrapper } from 'academy-common-lib/components/Skeletons/subcomponents/Skeleton';
import { PageSectionHeading } from '../SectionHeading';
import { Box } from 'foundations-components/transitional/components/Box';
import CardsSection from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { InProgressSectionSimplified } from '../../features/userProgress/components/InProgressSectionSimplified';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HomePageContent = () => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const {
    loading: contentOrderLoading,
    items: contentOrder
  } = usePersonalizedHomepageOrder();
  const handleRenderEmpty = useCallback(bar => {
    Metrics.counter('homepage-carousel-bar-empty', {
      bar
    }).increment();
  }, []);
  const dynamicContent = useMemo(() => {
    const dynamicComponentMapping = {
      'internal-content': /*#__PURE__*/_jsx(FeaturedSection, {
        onRenderEmpty: () => handleRenderEmpty('internal-content'),
        renderCompact: isTablet
      }),
      'in-progress': /*#__PURE__*/_jsx(InProgressSectionSimplified, {
        onRenderEmpty: () => handleRenderEmpty('in-progress')
      }),
      'persona-based-recommendations': /*#__PURE__*/_jsx(PersonaRecommendations, {
        onRenderEmpty: () => handleRenderEmpty('persona-based-recommendations')
      }),
      'progress-based-recommendations': /*#__PURE__*/_jsx(View, {
        "data-test-id": "pre-catalog-cards-container",
        children: /*#__PURE__*/_jsx(RecommendationsContainer, {
          cardSize: "large",
          onRenderEmpty: () => handleRenderEmpty('progress-based-recommendations')
        })
      }),
      'popular-certificates': /*#__PURE__*/_jsx(View, {
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(MostPopularCertificates, {
          onRenderEmpty: () => handleRenderEmpty('popular-certificates')
        })
      })
    };
    return contentOrder.map(barType => dynamicComponentMapping[barType]);
  }, [contentOrder, handleRenderEmpty, isTablet]);
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(GetStartedSearchPrompt, {
      includeKeywords: false
    }), !!dynamicContent.length && /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_SIMPLIFIED_LOADED",
      children: /*#__PURE__*/_jsx(SectionCarousel, {
        children: dynamicContent
      })
    }), !contentOrderLoading && /*#__PURE__*/_jsx(AnnouncementsSection, {}), contentOrderLoading && !dynamicContent.length && /*#__PURE__*/_jsxs(HomePageSection, {
      paddingBlock: "0",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        marginBlockEnd: isMobile ? '200' : '400',
        children: /*#__PURE__*/_jsx(Box, {
          grow: 2,
          children: /*#__PURE__*/_jsx(PageSectionHeading, {
            marginBlockEnd: "0",
            subtitle: /*#__PURE__*/_jsx(SkeletonWrapper, {
              height: 18,
              width: 300,
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                height: 18,
                width: 300
              })
            }),
            title: /*#__PURE__*/_jsx(SkeletonWrapper, {
              height: 25,
              width: 200,
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                height: 25,
                width: 200
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(CardsSection, {
        appearsIn: "simplified-homepage",
        cardsContainerProps: {
          paddingBlockEnd: '0'
        },
        direction: isTablet ? 'column' : 'row',
        isLoading: true,
        maxSkeletonListLength: isTablet ? 3 : 4,
        size: isTablet ? 'small' : 'large'
      })]
    })]
  });
};
const HomePageLayout = () => {
  useWootricSurvey('CES');
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(HomePageContent, {});
};
export default HomePageLayout;